import type { Catalog } from "../../en";

/** Filipino: platform admin system screen (mirrors en). */
export const system: Catalog["adminScreens"]["system"] = {
  title: "Kalusugan ng sistema",
  subtitle: "Live na probe ng mga serbisyo, queue, job at database ng platform · nire-refresh tuwing 30 segundo",
  scheduleMaintenance: "Mag-iskedyul ng maintenance",
  summary: {
    allUp: "Gumagana lahat ng {{count}}",
    mixed: "{{bad}} kailangang tingnan · {{ok}} gumagana",
  },
  status: { up: "Gumagana", degraded: "Degraded", down: "Down", unknown: "Hindi alam" },
  services: {
    title: "Mga serbisyo",
    caption: "Live na status at bilis ng tugon ng probe",
    latency: "Latency",
    detail: "Detalye",
    emptyTitle: "Walang naiulat na serbisyo",
    emptyBody: "Walang ibinalik na probe ang health service. Tiyaking naaabot ng API ang mga dependency nito.",
  },
  queues: {
    title: "Mga queue",
    caption: "Mga background worker queue sa Redis · huling 24 oras",
    colQueue: "Queue",
    colStatus: "Status",
    colDepth: "Lalim",
    colSucceeded: "Tapos (24h)",
    colOldest: "Pinakalumang job",
    colFailed: "Pumalya (24h)",
    colActions: "Mga aksyon",
    states: { healthy: "Maayos", elevated: "Mataas", paused: "Naka-pause" },
    pause: "I-pause",
    resume: "Ituloy",
    retry: "Ulitin ang pumalya",
    scale: "Dagdag +{{count}}",
    paused: "Naka-pause ang {{queue}} · tatapusin ng workers ang mga kasalukuyang job",
    resumed: "Itinuloy ang {{queue}}",
    retried_one: "{{count}} pumalyang job ang ibinalik sa {{queue}}",
    retried_other: "{{count}} pumalyang job ang ibinalik sa {{queue}}",
    noFailed: "Walang pumalyang job sa {{queue}}",
    scaled: "Hiniling ang dagdag na {{count}} worker para sa {{queue}}",
    elevated: "Mataas ang {{queue}}: {{depth}} job ang naghihintay, {{failed}} ang pumalya sa 24h. Ulitin ang mga pumalya o humiling ng dagdag na worker.",
    actionsFor: "Mga aksyon para sa {{queue}}",
    emptyTitle: "Walang naka-rehistrong queue",
    emptyBody: "Lalabas dito ang mga worker queue kapag nag-ulat na ang worker pool.",
    descriptions: {
      ingest_parse: "Pag-parse ng dokumento, layout at table extraction",
      ingest_ocr: "OCR para sa mga na-scan na PDF at larawan",
      ingest_enrich: "Paggawa ng context para sa mga chunk",
      ingest_embed: "Embeddings para sa bago at binagong chunk",
      crawl: "Pag-crawl ng website at naka-iskedyul na re-sync",
      notify: "Email at push notification",
      webhooks: "Pagpapadala ng outbound webhook",
      eval: "Mga evaluation suite (LLM-as-judge)",
      default: "Pangkalahatang background task",
    },
  },
  jobs: {
    title: "Live na job feed",
    pause: "I-pause ang feed",
    resume: "Ituloy ang feed",
    pausedNote: "Naka-pause ang feed",
    states: { succeeded: "Tapos", running: "Tumatakbo", failed: "Pumalya", queued: "Nakapila", cancelled: "Kinansela" },
    stage: "Yugto: {{stage}}",
    attempts_one: "{{count}} subok",
    attempts_other: "{{count}} subok",
    duration: "{{ms}} ms",
    untitled: "Source na walang pamagat",
    emptyTitle: "Walang kamakailang job",
    emptyBody: "Lalabas dito ang mga ingestion job habang nag-a-upload o nagsi-sync ng kaalaman ang mga tenant.",
  },
  latency: {
    title: "Latency",
    caption: "Huling {{hours}}h · {{count}} sample",
    metricLabel: "Sukatan ng latency",
    metrics: { ttft: "Oras bago ang unang token", retrieval: "Retrieval" },
    p50: "p50",
    p95: "p95",
    slo: "SLO p95",
    noSlo: "Walang SLO",
    sloMeter: "p95 kumpara sa SLO",
    withinSlo: "Pasok sa SLO",
    overSlo: "Lampas sa SLO",
    noSamples: "Walang sample sa panahong ito",
    noSamplesBody: "Lalabas ang latency kapag may na-trace na traffic sa huling {{hours}} oras.",
  },
  database: {
    title: "Database",
    engine: "PostgreSQL {{version}} · pgvector {{pgvector}}",
    engineNoVector: "PostgreSQL {{version}} · walang pgvector",
    size: "Laki ng DB",
    chunkRows: "Mga row ng chunk",
    vectorIndexes: "Mga vector index",
    hnsw: "HNSW",
    hnswPresent: "Mayroon",
    hnswMissing: "Wala",
    connections: "Mga koneksyon",
    connectionsValue: "{{used}} / {{max}}",
    tables: "Pinakamalalaking table",
    colTable: "Table",
    colRows: "Live na row",
    colDead: "Patay na row",
    colSize: "Laki",
    colVacuum: "Huling autovacuum",
    never: "Hindi pa",
    connectionsWarn: "Lampas 80% ng limit ang koneksyon — suriin ang pooling bago lumaki ang traffic.",
  },
  incidents: {
    title: "Mga insidente at maintenance",
    declare: "Magdeklara ng insidente",
    scheduled: "Naka-iskedyul: {{title}}",
    window: "{{start}} · {{duration}}",
    impacts: {
      none: "Walang inaasahang downtime",
      read_only: "Maikling read-only (gumagana ang chat, naka-pause ang upload)",
      full_outage: "Buong outage — offline na mensahe sa widget",
    },
    services: "Apektado: {{services}}",
    edit: "I-edit",
    cancel: "Kanselahin ang window",
    cancelled: "Kinansela ang maintenance",
    severity: { sev1: "SEV-1", sev2: "SEV-2", sev3: "SEV-3" },
    states: { investigating: "Sinisiyasat", monitoring: "Binabantayan", resolved: "Naresolba" },
    started: "Nagsimula {{when}}",
    lasted: "{{duration}}",
    fix: "Ayos: {{fix}}",
    postmortem: "Post-mortem",
    markMonitoring: "Markahang binabantayan",
    resolve: "Resolbahin",
    resolved: "Naresolba ang {{code}}",
    monitoring: "Binabantayan na ang {{code}}",
    emptyTitle: "Walang insidente o maintenance",
    emptyBody: "Lalabas dito ang mga idineklarang insidente at naka-iskedyul na maintenance.",
  },
  durations: { "15": "15 min", "30": "30 min", "60": "1 oras", "120": "2 oras" },
  elapsed: { minutes: "{{m}} min", hours: "{{h}}h {{m}}m", days: "{{d}}a {{h}}h", seconds: "{{s}}s" },
  maintenanceDialog: {
    title: "Mag-iskedyul ng maintenance",
    editTitle: "I-edit ang maintenance",
    description: "Makikita ng mga tenant ang window sa kanilang console at sa mga notification na pipiliin mo.",
    editDescription: "Hindi na mababago ang epekto, serbisyo at notification kapag naka-iskedyul na.",
    titleLabel: "Pamagat",
    titlePlaceholder: "hal. PostgreSQL minor upgrade",
    date: "Petsa",
    start: "Simula (PHT)",
    duration: "Tagal",
    impact: "Epekto",
    services: "Mga apektadong serbisyo",
    notification: "Abiso sa tenant",
    notify: {
      email: "I-email ang lahat ng tenant owner at admin",
      banner_72h: "In-app banner sa tenant console mula 72h bago",
      status_page: "I-post sa pampublikong status page",
    },
    message: "Mensahe sa mga tenant",
    messagePlaceholder: "Ano ang magbabago, kailan, at kung may kailangang gawin ang tenant.",
    submit: "Iskedyul at abisuhan",
    save: "I-save ang mga pagbabago",
    scheduled: "Naka-iskedyul ang maintenance · aabisuhan ang mga tenant",
    updated: "Na-update ang maintenance window",
    titleRequired: "Bigyan ng pamagat ang window.",
    dateRequired: "Pumili ng petsa at oras ng simula.",
    pastStart: "Pumili ng oras ng simula sa hinaharap.",
  },
  incidentDialog: {
    title: "Magdeklara ng insidente",
    description: "Magbubukas ng insidente sa timeline ng platform. Resolbahin ito mula sa Incidents card.",
    summary: "Buod",
    summaryPlaceholder: "hal. Backlog sa embedding queue na nagpapabagal ng upload",
    summaryRequired: "Ilarawan ang insidente sa ilang salita.",
    severity: "Tindi",
    severities: { sev3: "SEV-3 · maliit", sev2: "SEV-2 · degraded", sev1: "SEV-1 · outage" },
    lead: "Lead ng insidente",
    you: "{{name}} (ikaw)",
    impact: "Epekto",
    impactPlaceholder: "Sino ang apektado at paano",
    statusPage: "I-post sa status page",
    submit: "Ideklara",
    declared: "Naideklara ang insidenteng {{code}}",
  },
};
